import React from 'react';
import {Link} from 'react-router-dom';
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faPlusCircle, faCheck, faArchive} from "@fortawesome/free-solid-svg-icons";

import SidebarNavItems from "./SidebarNavItems";

import "./Sidebar.css";

const Sidebar = ({activeProjectId, clsActive, handleOpenArchiveModal, handleOpenPurgeModal, list}) => {
  return (
    <div className={`sidebar ${clsActive} d-flex flex-column`}>
      <div className="sidebar-header d-flex align-items-center justify-content-between">
        <div className="sidebar-header-text">Drawings</div>
        {
          activeProjectId!="new" &&
          <Link
            to="/new"
            className="sidebar-header-btn-link"
          >
            <div className="sidebar-header-btn">
              <FontAwesomeIcon
                className="sidebar-header-btn-icon"
                icon={faPlusCircle}
              />
            </div>
          </Link>
        }
      </div>

      <div className="sidebar-section-header d-flex align-items-center">
        <FontAwesomeIcon
          className="sidebar-section-header-icon"
          icon={faCheck}
        />

        <div className="sidebar-section-header-text">Current Drawings</div>
      </div>

      <ul className="sidebar-nav">
        <SidebarNavItems
          list={list}
          filter="current"
          activeProjectId={activeProjectId}
          handleOpenArchiveModal={handleOpenArchiveModal}
        />
      </ul>

      <div className="sidebar-section-header d-flex align-items-center">
        <FontAwesomeIcon
          className="sidebar-section-header-icon"
          icon={faArchive}
        />
        
        <div className="sidebar-section-header-text">Archived Drawings</div>
      </div>

      <ul className="sidebar-nav">
        <SidebarNavItems
          list={list}
          filter="archived"
          activeProjectId={activeProjectId}
          handleOpenPurgeModal={handleOpenPurgeModal}
        />
      </ul>
    </div>
  );
};

export default Sidebar;
